import { useLocation, useNavigate } from "react-router-dom";
import Layout from "../../components/layout/Layout";
import { formatDate } from "../../helpers/DateConversion";

export default function ViewAccessory() {
  const location = useLocation();
  const data = location.state.data;

  const navigate = useNavigate();

  return (
    <div>
      <Layout>
        <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-medium">View Accessory</h2>

            <button
              onClick={() => navigate(-1)}
              className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
            >
              Back
            </button>

          </div>

          <div className="mt-10">
            <div className="my-6">
              <img
                src={`${process.env.REACT_APP_MEDIA_BASE_URL}/${data.imageUrl}`}
                className="h-[100px] w-[100px] rounded-full border-2"
                alt=""
              />
            </div>
          </div>

          <div className="mt-10">
            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Accessory Name</h6>
                <p className="mt-1">{data?.name}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Accessory Type</h6>
                <p className="mt-1">{data?.type}</p>
              </div>
            </div>
            <hr />

            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Material</h6>
                <p className="mt-1">{data?.material}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Price</h6>
                <p className="mt-1">{data?.price}</p>
              </div>
            </div>
            <hr />

            {/* <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Description</h6>
                <p className="mt-1">{data.description}</p>
              </div>
            </div>
            <hr /> */}
            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Stock Quantity</h6>
                <p className="mt-1">{data.stockQuantity}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Status</h6>
                <p className="mt-1">{data.status}</p>
              </div>
            </div>

            <hr />
            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Discounted Price</h6>
                <p className="mt-1">{data.discountPrice}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Created At</h6>
                <p className="mt-1">{formatDate(data.createdAt)}</p>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
}
